import React, { useContext, useMemo } from 'react';
import { FormLocalDateTimeField, InternalSettings } from '@eas/common-web';
import {
  InlineCellOptions,
  InlineTableFieldContext,
  TableFieldCellProps,
} from '@eas/common-web';
import { EasSetting } from '@eas/common-web/dist/types/settings/internal/internal-settings-types';

interface InlineDateFieldCellOptions extends InlineCellOptions {
  representation?: 'local-date' | 'local-date-time' | 'instant';
}

function useInlineDateFieldFactory<OBJECT>(props: InlineDateFieldCellOptions) {
  return useMemo(
    () =>
      function InlineCell(tableFieldProps: TableFieldCellProps<OBJECT>) {
        return (
          <InlineDateFieldCell<OBJECT>
            inlineProps={props}
            tableFieldProps={tableFieldProps}
          />
        );
      },
    [props]
  );
}

function InlineDateFieldCell<OBJECT>({
  inlineProps,
  tableFieldProps,
}: {
  inlineProps: InlineDateFieldCellOptions;
  tableFieldProps: TableFieldCellProps<OBJECT>;
}) {
  const { disabled: tableDisabled } = useContext(InlineTableFieldContext);

  const {
    isSubkey = true,
    collectionDatakey,
    disabled,
    representation,
  } = inlineProps;
  const { index, column } = tableFieldProps;

  return (
    <FormLocalDateTimeField
      name={
        isSubkey
          ? `${collectionDatakey}[${index}].${column.datakey}`
          : `${collectionDatakey}[${index}]`
      }
      labelOptions={{ hide: true }}
      layoutOptions={{ noUnderline: true }}
      disabled={
        tableDisabled ||
        (typeof disabled === 'function' ? disabled(index) : disabled)
      }
      representation={representation}
    />
  );
}

function DateTimeCell(props: any) {
  return <FormLocalDateTimeField {...props} />;
}

export function GlobalSettings() {
  return (
    <InternalSettings
      config={[
        {
          code: 'ZSD_RETENTION_WINDOW_FROM',
          ColumnCell: (props: InlineDateFieldCellOptions) => {
            return useInlineDateFieldFactory<EasSetting>({
              ...props,
              representation: 'local-date-time',
            });
          },
          FieldComponent: DateTimeCell,
        },
        {
          code: 'ZSD_RETENTION_WINDOW_TO',
          ColumnCell: (props: InlineDateFieldCellOptions) => {
            return useInlineDateFieldFactory<EasSetting>({
              ...props,
              representation: 'local-date-time',
            });
          },
          FieldComponent: DateTimeCell,
        },
      ]}
    />
  );
}
